import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { HeaderComponent } from './structure/header/header.component';
import { SidebarComponent } from './structure/sidebar/sidebar.component';
import { RouterModule } from '@angular/router';
import { LoaderComponent } from '../core/custome-modal/loader/loader.component';
import { FooterComponent } from './structure/footer/footer.component';
@Component({
  selector: 'app-layout',
  standalone: true,
  imports: [
    CommonModule,
    RouterModule,
    HeaderComponent,
    SidebarComponent,
    LoaderComponent,
  ],
  templateUrl: './layout.component.html',
  styleUrls: ['./layout.component.scss'],
})
export class LayoutComponent { }
